/** Resolved output URL for a job (legacy upscaleUrl or newer image field). */
export function getJobResultUrl(job) {
  return job?.upscaleUrl || job?.image || '';
}

/** True when the job has no finished image yet. */
export function isJobRendering(job) {
  if (getJobResultUrl(job)) {
    return false;
  }
  const status = job?.status;
  if (status === 'finished' || status === 'failed' || status === 'failed-face' || status === 'nsfw') {
    return false;
  }
  return true;
}
